export enum StoreFilterProperty {
  aov = 1,
  region = 2,
  area = 3,
  state = 4,
  city = 5,
  name = 6,
  typeName = 7,
  groupName = 8,
  dealerNumber = 9,
  idStoreMatrix = 10,
  status = 11
}
